import { lazy } from 'react'
import type { RouteObject } from 'react-router-dom'

const ChangeProLayout = lazy(() =>
  import('../components/change-pro/ChangeProLayout').then((m) => ({ default: m.ChangeProLayout }))
)
const ChangeProHubPage = lazy(() =>
  import('../pages/change-pro').then((m) => ({ default: m.HubPage }))
)
const ChangeProCockpitPage = lazy(() =>
  import('../pages/change-pro').then((m) => ({ default: m.CockpitPage }))
)
const ChangeProScorePage = lazy(() =>
  import('../pages/change-pro').then((m) => ({ default: m.ScorePage }))
)
const ChangeProMaturitePage = lazy(() =>
  import('../pages/change-pro').then((m) => ({ default: m.MaturitePage }))
)
const ChangeProAdkarPage = lazy(() =>
  import('../pages/change-pro').then((m) => ({ default: m.AdkarPage }))
)
const ChangeProKotterPage = lazy(() =>
  import('../pages/change-pro').then((m) => ({ default: m.KotterPage }))
)
const ChangeProLewinBridgesPage = lazy(() =>
  import('../pages/change-pro').then((m) => ({ default: m.LewinBridgesPage }))
)
const ChangeProMcKinsey7sPage = lazy(() =>
  import('../pages/change-pro').then((m) => ({ default: m.McKinsey7sPage }))
)
const ChangeProRoadmapPage = lazy(() =>
  import('../pages/change-pro').then((m) => ({ default: m.RoadmapPage }))
)
const ChangeProAdoptionPage = lazy(() =>
  import('../pages/change-pro').then((m) => ({ default: m.AdoptionPage }))
)
const ChangeProResistancePage = lazy(() =>
  import('../pages/change-pro').then((m) => ({ default: m.ResistancePage }))
)
const ChangeProImpactPage = lazy(() =>
  import('../pages/change-pro').then((m) => ({ default: m.ImpactPage }))
)
const ChangeProCommunicationPage = lazy(() =>
  import('../pages/change-pro').then((m) => ({ default: m.CommunicationPage }))
)
const ChangeProChampionsPage = lazy(() =>
  import('../pages/change-pro').then((m) => ({ default: m.ChampionsPage }))
)
const ChangeProCulturePage = lazy(() =>
  import('../pages/change-pro').then((m) => ({ default: m.CulturePage }))
)
const ChangeProEnpsPage = lazy(() =>
  import('../pages/change-pro').then((m) => ({ default: m.EnpsPage }))
)
const ChangeProPortfolioPage = lazy(() =>
  import('../pages/change-pro').then((m) => ({ default: m.PortfolioPage }))
)
const ChangeProReadinessPage = lazy(() =>
  import('../pages/change-pro').then((m) => ({ default: m.ReadinessPage }))
)
const ChangeProFormationPage = lazy(() =>
  import('../pages/change-pro').then((m) => ({ default: m.FormationPage }))
)
const ChangeProRoiPage = lazy(() =>
  import('../pages/change-pro').then((m) => ({ default: m.RoiPage }))
)
const ChangeProReportExecPage = lazy(() =>
  import('../pages/change-pro').then((m) => ({ default: m.ChgProReportExecPage }))
)
const ChangeProIntegrationPage = lazy(() =>
  import('../pages/change-pro').then((m) => ({ default: m.ChgProIntegrationPage }))
)
const ChangeProAuditTrailPage = lazy(() =>
  import('../pages/change-pro').then((m) => ({ default: m.ChgProAuditTrailPage }))
)
const ChangeProSettingsPage = lazy(() =>
  import('../pages/change-pro').then((m) => ({ default: m.ChgProSettingsPage }))
)
const ChgProOutilsPage = lazy(() =>
  import('../pages/change-pro').then((m) => ({ default: m.ChgProOutilsPage }))
)
const ChangeProChangeSuccessPredictionPage = lazy(() =>
  import('../pages/change-pro/ChangeSuccessPredictionPage').then((m) => ({ default: m.ChangeSuccessPredictionPage }))
)

export const changeProRoutes: RouteObject[] = [
  {
    path: '/change-pro',
    element: <ChangeProLayout />,
    children: [
      { index: true, element: <ChangeProHubPage /> },

      { path: 'hub', element: <ChangeProHubPage /> },
      { path: 'cockpit', element: <ChangeProCockpitPage /> },
      { path: 'score', element: <ChangeProScorePage /> },
      { path: 'maturite', element: <ChangeProMaturitePage /> },
      { path: 'adkar', element: <ChangeProAdkarPage /> },
      { path: 'kotter', element: <ChangeProKotterPage /> },
      { path: 'lewin-bridges', element: <ChangeProLewinBridgesPage /> },
      { path: 'mckinsey-7s', element: <ChangeProMcKinsey7sPage /> },
      { path: 'roadmap', element: <ChangeProRoadmapPage /> },
      { path: 'adoption', element: <ChangeProAdoptionPage /> },
      { path: 'resistance', element: <ChangeProResistancePage /> },
      { path: 'impact', element: <ChangeProImpactPage /> },
      { path: 'communication', element: <ChangeProCommunicationPage /> },
      { path: 'champions', element: <ChangeProChampionsPage /> },
      { path: 'culture', element: <ChangeProCulturePage /> },
      { path: 'enps', element: <ChangeProEnpsPage /> },
      { path: 'portfolio', element: <ChangeProPortfolioPage /> },
      { path: 'readiness', element: <ChangeProReadinessPage /> },
      { path: 'formation', element: <ChangeProFormationPage /> },
      { path: 'roi', element: <ChangeProRoiPage /> },
      { path: 'report-exec', element: <ChangeProReportExecPage /> },
      { path: 'integrations', element: <ChangeProIntegrationPage /> },
      { path: 'audit-trail', element: <ChangeProAuditTrailPage /> },
      { path: 'settings', element: <ChangeProSettingsPage /> },
      { path: 'outils', element: <ChgProOutilsPage /> },
      { path: 'change-prediction', element: <ChangeProChangeSuccessPredictionPage /> },
    ],
  },
]
